import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export async function fetchVisitors() {
  const { data } = await axios.get(`${API}/visitors`);
  return data;
}

export async function fetchVisitor(id) {
  const { data } = await axios.get(`${API}/visitors/${id}`);
  return data;
}

export async function fetchVisitorStats() {
  const { data } = await axios.get(`${API}/visitors/stats`);
  return data;
}

export async function createVisitor(payload) {
  const { data } = await axios.post(`${API}/visitors`, payload);
  return data;
}

export async function updateVisitor(id, payload) {
  const { data } = await axios.put(`${API}/visitors/${id}`, payload, {
    params: { own_token: getOwnToken() },
  });
  return data;
}

export async function deleteVisitor(id) {
  const { data } = await axios.delete(`${API}/visitors/${id}`, {
    params: { own_token: getOwnToken() },
  });
  return data;
}

export async function seedVisitors() {
  const { data } = await axios.post(`${API}/visitors/seed`);
  return data;
}

// Local identity (lets a user identify their own card across visits)
const TOKEN_KEY = 'manisha_visitor_token';
export function getOwnToken() {
  let t = localStorage.getItem(TOKEN_KEY);
  if (!t) {
    t = 'tok_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem(TOKEN_KEY, t);
  }
  return t;
}

const OWN_ID_KEY = 'manisha_visitor_own_id';
export function setOwnVisitorId(id) {
  localStorage.setItem(OWN_ID_KEY, id);
}
export function getOwnVisitorId() {
  return localStorage.getItem(OWN_ID_KEY);
}

export function clearOwnVisitorId() {
  localStorage.removeItem(OWN_ID_KEY);
}

const COLOR_KEY = 'manisha_visitor_color';
export const DEFAULT_ACCENT_COLOR = '#c4757e';

export function setOwnVisitorColor(value) {
  if (value) {
    localStorage.setItem(COLOR_KEY, value);
    window.dispatchEvent(new CustomEvent('visitor-color-change', { detail: value }));
  }
}

export function getOwnVisitorColor() {
  return localStorage.getItem(COLOR_KEY) || DEFAULT_ACCENT_COLOR;
}
